export class JsonElementParser {

    /**
     * Parses an html element with the given id as JSON.
     * Url-encoded properties will remain URL encoded.
     * Returns null if the element does not exist
     */
    public static parseJsonElementWithId(elementId: string): any {
        const jsonElement = document.getElementById(elementId);

        // IMPORTANT: we use 'textContent' here since it fully decodes the
        // HTML-encoded content of the element. 'innerHTML' does not fully decode the contents.
        const jsonText = jsonElement && jsonElement.textContent;
        if (jsonText) {
            return JSON.parse(jsonText);
        } else {
            return null;
        }
    }

    public static decodeJsonString(jsonText: string) : string {
        // IMPORTANT: In case JSON contains encoded strings we need decode them one by one before parsing.
        const jsonValues = jsonText.split('"');
        jsonValues.forEach((value, index, array) => {
            const decodedValue = decodeURIComponent(value);
            // Decoded value may contain double quotation symbol (") which has to be escaped (\")
            array[index] = decodedValue.replace(/"/g, '\\"');
        });

        // Reconstruct the original string with all values properly decoded
        const unencodedJsonText = jsonValues.join('"');

        return unencodedJsonText;
    }
}
